export default {
    person: {
        citizenship: 'Citizenship',
        lastEmployer: 'Last Employer',
        untilNow: 'till now.',
        working: 'History',
        institute: 'Institute',
        graduation: 'Graduation',
        experience: 'Experience',
        organization: 'Company',
        position: 'Position',
        department: 'Department',
        speciality: 'Speciality',
        education: {
            title: 'Education',
        },
        work: {
            title: 'Work',
        },
        contacts: {
            title: 'Contacts'
        },
        address: {
            title: 'Address'
        },
        additional: {
            title: 'Additional Information'
        },
        comments: 'Notes',
        fullName: 'Full Name',
        projects: 'Projects',
        tags: 'Tags',
        phone: 'Phone',
    },
};
